module.exports = __webpack_public_path__ + "static/media/christine_img.ff269f21.svg";